export default "__VITE_ASSET__CspXiGb2__"